import React from 'react';
import { Title } from '@/components/Typography';

export function Header(): JSX.Element {
	return (
		<Title level={3} style={{ textAlign: 'center' }}>
			OWAS
		</Title>
	);
}
